import { buildRouteHead } from "@/lib/seo/routeHead";
import { createFileRoute, redirect } from "@tanstack/react-router";

export const Route = createFileRoute("/en/services/one-vigilance/regulatory-intelligence")({
  head: () => buildRouteHead("/en/services/one-vigilance/regulatory-intelligence", { noIndex: true }),
  beforeLoad: () => {
    throw redirect({ to: "/en/services/pharmacovigilance/regulatory-intelligence", replace: true });
  },
});
